import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuthStore } from '@/features/auth/model/auth-store';

import { authService } from '@/shared/api/auth-service';
import { ROUTES } from '@/shared/config/routes';
import { logger } from '@/shared/lib/logger';
import { supabase } from '@/shared/lib/supabase';
import { LoadingSpinner } from '@/shared/ui';

export const AuthCallbackPage = () => {
  const navigate = useNavigate();
  const { login } = useAuthStore();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        const { data, error } = await supabase.auth.getSession();

        if (error) {
          logger.auth.error('Auth callback error', { error });
          navigate(ROUTES.AUTH.REGISTER);
          return;
        }

        if (data.session?.user) {
          // Get user data from your API
          try {
            const userResponse = await authService.getMe();

            if (userResponse.type === 'success' && 'id' in userResponse.data) {
              // Supabase already has the session stored, just update user data
              login(userResponse.data);
              navigate(ROUTES.HOME);
            } else {
              navigate(ROUTES.AUTH.REGISTER);
            }
          } catch (apiError) {
            logger.auth.error('Failed to get user data during auth callback', { error: apiError });
            navigate(ROUTES.AUTH.REGISTER);
          }
        } else {
          navigate(ROUTES.AUTH.REGISTER);
        }
      } catch (error) {
        logger.auth.error('Auth callback error', { error });
        navigate(ROUTES.AUTH.REGISTER);
      }
    };

    handleAuthCallback();
  }, [navigate, login]);

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
      <div className="text-center">
        <LoadingSpinner className="w-8 h-8 mx-auto mb-4" />
        <p className="text-zinc-400">Completing sign in...</p>
      </div>
    </div>
  );
};
